import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { vendornegotiationservice } from '../../vendornegotiation.service';

@Component({
  selector: 'app-item-details',
  templateUrl: './item-details.component.html',
  styleUrls: ['./item-details.component.scss']
})
export class ItemDetailsComponent implements OnInit {
  itemData: any=[];
  vendorId: any;

 
  constructor(
    public dialogRef: MatDialogRef<ItemDetailsComponent>,
    @Inject(MAT_DIALOG_DATA) public dialogData: any,
    private vendorNegoService:vendornegotiationservice,
  ) {
    
  }
  ngOnInit(): void {
    const storedData = localStorage.getItem('user_details') ?? "{}";
    const userDetails = JSON.parse(storedData);
    this.vendorId = userDetails.vendor_id;
  this.getDataOnnegotiationFrequencyId();
  }
  getDataOnnegotiationFrequencyId(){
    let data={
      negotiationFrequency:this.dialogData.itemdata.negotiationFrequency,
      vendor_id:this.vendorId
    }
    this.vendorNegoService.getDataOnnegotiationFrequencyId(data).subscribe((res:any)=>{
       if(res.body.data){
        this.itemData=res.body.data;
       }
    },(err:any)=>{

    })
  }
  close(){
    this.dialogRef.close();
  }
}
